import React, { useRef } from 'react';
import Biofouling2Print from './BiofoulingPrint';
import { IStore } from '../../../../../redux/store';
import { bfl2Actions, bfl2Selectors } from '../../../../../redux/app/bfl-2';
import { Dispatch } from 'redux';
import { TBFL2HistoryFilters } from '../../../../../redux/app/bfl-2/@types';
import { ConnectedProps, connect } from 'react-redux';
import Biofouling2CoverPage from './BiofoulingCoverPage';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';
import { marpolSelectors } from '../../../../../redux/app/marpol';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type Biofouling2HistoryProps = PropsFromRedux & OwnProps;

function Biofouling2InspectorView(props: Biofouling2HistoryProps) {
    const { historyList, showCoverPages, tanks, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? (
                <Biofouling2CoverPage vesselId={vesselId}>
                    <div className="flex justify-center">
                        <h3 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                            PART II - Monitoring of biofouling risk parameters
                        </h3>
                    </div>
                </Biofouling2CoverPage>
            ) : null}

            <div className="py-4 newpage">
                <Biofouling2Print
                    key={'temp-print-id-bfl2'}
                    isPrintVisible={true}
                    biofoulingRecords={historyList}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const biofoulingRecordStore = bfl2Selectors._getStore(store);
    const marpolStore = marpolSelectors._getStore(store);
    const tanks = marpolSelectors.getTanks(marpolStore);

    return {
        historyList: bfl2Selectors.getHistoryList(biofoulingRecordStore),
        jobToLoadHistory: bfl2Selectors.jobToLoadHistory(biofoulingRecordStore),
        tanks,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {
        load(filters: TBFL2HistoryFilters) {
            return dispatch(bfl2Actions.commands.historyLoad(filters));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Biofouling2InspectorView);
